<script lang="ts">
  import SvelteMarkdown from "svelte-markdown";
  import { Container } from "sveltestrap";
  import { logEvent } from "../helpers/analytics";
  import faq from "../pages/faq.md";
  import privacyPolicy from "../pages/privacy-policy.md";
  import subprocessors from "../pages/subprocessors.md";
  import tos from "../pages/terms-of-service.md";
  import NotFound from "./NotFound.svelte";

  export let params: Record<string, string> | null = {};
  let source: string;

  if (params) {
    switch (params.type) {
      case "privacy-policy":
        source = privacyPolicy;
        break;
      case "terms-of-service":
        source = tos;
        break;
      case "faq":
        source = faq;
        break;
      case "subprocessors":
        source = subprocessors;
        break;
    }
    logEvent("open_policy", { policy: params.type });
  }
</script>

<div class="policy-container">
  <Container style="text-align: left;">
    <div class="inside-margin">
      {#if params && source}
        <SvelteMarkdown {source} />
      {:else}
        <NotFound />
      {/if}
    </div>
  </Container>
</div>

<style>
  .policy-container {
    padding-top: 5vh;
  }

  .inside-margin {
    padding: 15px;
  }
</style>
